import { ReactComponentElement } from 'react';

import { MeasurementFieldType } from 'models';

import {
    MaximumMeasurementInput,
    MeasurementInput,
    MeasurementInputProps,
    MinimumMeasurementInput,
    NominalMeasurementInput,
} from './MeasurementInput';
import { UnitElement } from './types';
import { FieldsRecord } from './useMultiUnitMeasurementController';

type Props = {
    fields: MeasurementFieldType[];
    fieldsRecord: FieldsRecord;
    Unit: UnitElement;
    extraProps?: Partial<MeasurementInputProps>;
};

type MeasurementInputElement = ReactComponentElement<typeof MeasurementInput>;

const useRenderVariableMultiInput = ({
    fields,
    fieldsRecord,
    Unit,
    extraProps = {},
}: Props): MeasurementInputElement[] => {
    return fields.map((field) => {
        const value = fieldsRecord[field];
        const Element = getMeasurementInputForField(field);

        return <Element key={field} {...value} unit={Unit} {...extraProps} />;
    });
};

const getMeasurementInputForField = (field: MeasurementFieldType) => {
    switch (field) {
        case 'min':
            return MinimumMeasurementInput;
        case 'nom':
            return NominalMeasurementInput;
        case 'max':
            return MaximumMeasurementInput;
        default:
            return MeasurementInput;
    }
};

export { useRenderVariableMultiInput };
